import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BTAccordion = React.lazy(function () {
    return import('../../bootstrap-components/components/BTAccordion');
});
var bootStrapAccordion = function (props) {
    return (React.createElement(BTAccordion, __assign({}, props)));
};
var Accordion = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapAccordion(props);
            break;
        default:
            componentToDisplay = bootStrapAccordion(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
Accordion.defaultProps = {
    styleName: 'secondary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(Accordion);
//# sourceMappingURL=Accordion.js.map